import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class RemoveRequest extends GenericRequest {

    commit;
    companyIds;
    workersIds;
    machinesIds;

    constructor(companyIds = [], workersIds = [], machinesIds = [], commit = false) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.BATCH_DELETE));

        this.companyIds = companyIds;
        this.workersIds = workersIds;
        this.machinesIds = machinesIds;
        this.commit = commit;
    }

    overrideRequest() {
        const request = {};
        request.companies = this.companyIds;
        request.workers = this.workersIds;
        request.machines = this.machinesIds;
        request.commit = this.commit;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/remove/ws/RemoveRequest.js